import React, { memo, useMemo } from 'react';
import { Label } from 'reactstrap';

export interface TableColumnProps extends React.HTMLAttributes<HTMLDivElement> {
  flex?: number | string;
  maxWidth?: number;
  width?: number;
  label?: boolean;
  noPadding?: boolean;
}

export const TableColumn = memo((props: TableColumnProps) => {
  const { flex = 1, maxWidth, children, width, style = {}, label = false, noPadding = false, ...rest } = props;
  const content = useMemo(() => (label ? <Label>{children}</Label> : children), [children, label]);
  return (
    <div {...rest} style={{ ...style, maxWidth, width, flex, padding: noPadding ? undefined : '0px 5px 0px 5px' }}>
      {content}
    </div>
  );
});
